export type Role = 'marketing' | 'sales';
export type Channel = 'email' | 'sms';
export type View = 'overview' | 'campaign' | 'recipient';

export const RANGE_OPTIONS = ['Last 30 days', 'Last 7 days', 'Quarter to date', 'Year to date'];

export const BRAND_OPTIONS = ['All brands', 'Roc', 'Civic', 'FACo'];

// Options of the select filters of the recipients table; the values are the ones the backend filters on
export const RECIPIENT_STATUS_OPTIONS = [
  { value: 'DELIVERED', label: 'Delivered' },
  { value: 'OPENED', label: 'Opened' },
  { value: 'CLICKED', label: 'Clicked' },
  { value: 'BOUNCED', label: 'Bounced' },
  { value: 'FAILED', label: 'Failed' },
  { value: 'SKIPPED', label: 'Skipped' },
];

// Skipped and failed emails are neither, as their Opened column is empty
export const RECIPIENT_OPENED_OPTIONS = [
  { value: 'opened', label: 'Opened' },
  { value: 'notOpened', label: 'Not opened' },
];

// Skip reasons saved by the sends; a reason missing here shows as it is saved
export const SKIP_REASON_LABELS: Record<string, string> = {
  DO_NOT_EMAIL: 'Do not email',
  BROKERED: 'Brokered',
  NO_EMAIL: 'No email address',
  INVALID_EMAIL: 'Invalid email',
  RECENTLY_SENT: 'Recently sent',
  IN_JOURNEY: 'In a journey',
  EXTERNAL_TPO_BORROWER: 'External TPO borrower',
};

// Labels of the columns and cards that change with the channel
export interface ChannelLabels {
  label: string;
  mid: string;
  engage: string | null;
  address: string;
  failTitle: string;
}

export const CHANNEL_LABELS: Record<Channel, ChannelLabels> = {
  email: {
    label: 'Email',
    mid: 'Open rate',
    engage: 'Click rate',
    address: 'Email address',
    failTitle: 'Bounce reasons',
  },
  sms: {
    label: 'SMS',
    mid: 'Reply rate',
    engage: null,
    address: 'Mobile number',
    failTitle: 'Delivery failure reasons',
  },
};

export const ROLE_NOTES: Record<Role, string> = {
  marketing: 'Centralized weekly and monthly sends',
  sales: 'Sends from your own book of business',
};
